import user from './user.js'
import key from './key.js'
import app from './app.js'
import flow from './flow.js'
export default {
  user,
  key,
  app,
  flow
}
